import React, { useMemo, useState } from 'react';
import styles from './index.module.less';
import Image from 'next/image';
import classNames from 'classnames';
import { imgUrl } from '@/shared/utils';
import { AppSettings } from '@/shared/app-common';
import { BlogItemTemplateDataModel } from '@/types/home';
import { Button } from 'antd';
import { useTranslation } from 'next-i18next';

const BestTipsContent = ({ title, blogList }: { title?: string; blogList?: BlogItemTemplateDataModel[] }) => {
  const { t } = useTranslation();
  const [page, setPage] = useState(1);
  // const [loading, setLoading] = useState(false)
  // const timerRef = useRef(null);

  // useEffect(() => {
  //   return () => {
  //     if (timerRef.current) {
  //       clearTimeout(timerRef.current);
  //     }
  //   };
  // }, []);

  // const handleClick = () => {
  //   setLoading(true);
  //   if (timerRef.current) {
  //     clearTimeout(timerRef.current);
  //   }
  //   timerRef.current = setTimeout(() => {
  //     setLoading(false);
  //     setPage((prevPage) => prevPage + 1);
  //   }, 1500);
  // };

  const showMore = useMemo(() => {
    return blogList?.length > page * 8;
  }, [page, blogList]);

  const getList = useMemo(() => {
    return blogList?.slice(0, Math.min(page * 8, blogList?.length));
  }, [page, blogList]);

  const getContent = () => {
    return blogList?.length > 0 ? (
      <div className={styles.content}>
        {title && <h2 className={styles.title}>{title}</h2>}

        <div className={styles.contentList}>
          {getList?.map((item, index) => (
            <div
              className={styles.contentItem}
              key={index}
              onClick={() => {
                window.open(`${AppSettings.blogHost}/instagram-tracking-blog/${item?.title_id}`, '_blank');
              }}
            >
              <div className={styles.contentItemImg}>
                <Image src={imgUrl(item.cover_image, 'mid')} alt={''} width={64} height={64} layout="responsive" />
              </div>

              <div className={classNames(styles.contentItemTitle)}>
                <h3 className={styles.subTitle}>{item.title}</h3>
                <p className={styles.subDesc}>{item.date}</p>
              </div>
            </div>
          ))}
        </div>

        {showMore && (
          <div className={styles.moreContainer}>
            <Button
              className={styles.moreBtn}
              onClick={() => {
                setPage(() => page + 1);
              }}
            >
              {`+ `}
              {t('loadMore')}
            </Button>
          </div>
        )}
      </div>
    ) : null;
  };

  return <>{getContent()}</>;
};

export default BestTipsContent;
